import type { FaireProductEntity } from "../../entity_types/product";

export const p_bduv7yjfrq: FaireProductEntity = {
  token: "p_bduv7yjfrq",
  type: "product",
  name: "Spooky Bats Halloween Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/684b5f4fb0772a336fcaa045f6d7f61221f14d472830f467c0ae86ba41924113.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aa796f6111d3755df67402255be9ab4b3269ba00062fca7beb04c16eee6862a9.jpeg",
  ],
  priceDollars: 3,
  description:
    "Each E. Frances card begins as an original watercolor painting, is then printed in brilliant color on luxe, heavyweight paper and is finally kissed with gold foil.\n \nMade in the USA.\n\nFeaturing cute and playful bat designs perfect for Halloween greetings. Ideal for trick-or-treat cards, Halloween party invites, or sharing festive cheer ",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:02.178Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
